export enum TerminalParameterKeys {
  WEB_CASH_CUSTOMER_SCREEN_TOUCH = 'WEB_CASH_CUSTOMER_SCREEN_TOUCH',
  WEB_CASH_SHOW_ROWS_IN_SEATS_PLAN = 'WEB_CASH_SHOW_ROWS_IN_SEATS_PLAN',
  WEB_CASH_SHOW_SEATS_NUMBERS = 'WEB_CASH_SHOW_SEATS_NUMBERS',
  WEB_CASH_DOCUMENTS_PRINTER_NAME = 'WEB_CASH_DOCUMENTS_PRINTER_NAME',
  WEB_CASH_DOCUMENTS_PRINT_DIRECTLY = 'WEB_CASH_DOCUMENTS_PRINT_DIRECTLY',
  WEB_CASH_SHOW_TUBE = 'WEB_CASH_SHOW_TUBE',
  WEB_CASH_RETURN_TO_NEXT_SHOW = 'WEB_CASH_RETURN_TO_NEXT_SHOW',
  WEB_CASH_SHOW_AUDITORIUM_SELECTION = 'WEB_CASH_SHOW_AUDITORIUM_SELECTION',
  CSH_PRINT_RECEIPT = 'CSH_PRINT_RECEIPT',
  CSH_BONPRINTER_PORT_CONFIG = 'CSH_BONPRINTER_PORT_CONFIG',
  CSH_TICKETPRINTER_PORT_CONFIG = 'CSH_TICKETPRINTER_PORT_CONFIG',
  CASH_EC_TERMINAL_IP = 'CASH_EC_TERMINAL_IP',
  CASH_EC_LIBRARY = 'CASH_EC_LIBRARY',
  CASH_EC_SUMUP_READER_ID = 'CASH_EC_SUMUP_READER_ID',
  CASH_EC_STANDALONE_TERMINAL = 'CASH_EC_STANDALONE_TERMINAL',
  CASH_EC_PRINT_LOCATION = 'CASH_EC_PRINT_LOCATION',
  CSH_SAFE_PORT = 'CSH_SAFE_PORT',
  WEB_CASH_TUBE_PLAY_DELAY = 'WEB_CASH_TUBE_PLAY_DELAY',
  CSH_SHOW_REMARK_DLG_FREEENTRIES = 'CSH_SHOW_REMARK_DLG_FREEENTRIES',
  ENABLE_REDEMPTION_OF_CINETIXX_CANCELLATION_VOUCHERS = 'ENABLE_REDEMPTION_OF_CINETIXX_CANCELLATION_VOUCHERS',
  CSH_USE_WORKER = 'CSH_USE_WORKER'
}
